import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { useStopwatch } from "react-timer-hook";
import MicRecorder from "mic-recorder-to-mp3";

export class AudioRecorder extends Component {
  constructor(props) {
    super(props);

    const BITRATE_AUDIO = 128; //kbps

    this.state = {
      recordState: null,
      audioData: null,
      infoAudio: {
        duration: 0,
        readyForSend: false
      },
      recorder: new MicRecorder({
        bitRate: BITRATE_AUDIO
      }),
      BITRATE_AUDIO: BITRATE_AUDIO //kbps
    };
  }

  start = () => {
    const { recorder } = this.state;
    recorder
      .start()
      .then(() => {
        this.props.changeButtonCommentForAudio(true);
        this.setState({
          recordState: "start"
        });
      })
      .catch(e => {
        this.props.changeButtonCommentForAudio(false);
        this.setState({
          recordState: "stop"
        });
        console.error(e);
      });
  };

  stop = sent => {
    this.setState({
      recordState: "stop"
    });
    this.props.changeButtonCommentForAudio(false);

    const { recorder } = this.state;
    recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        if (sent) {
          this.setState({
            audioData: { blob, type: "audio/mp3" }
          });
        } else this.clearAudio();
      })
      .catch(e => {
        console.log(e);
      });
  };

  sendAudio = () => {
    this.setState(
      {
        infoAudio: {
          readyForSend: true
        }
      },
      () => this.stop(true)
    );
  };

  cancelAudio = () => {
    this.setState(
      {
        infoAudio: {
          readyForSend: false
        }
      },
      () => this.stop(false)
    );
  };

  sendToS3 = () => {
    const { audioData } = this.state;
    if (audioData) {
      this.props.sendAudioMessage(audioData);
      this.clearAudio();
    }
  };

  clearAudio = () => {
    this.setState(({ BITRATE_AUDIO }) => ({
      recordState: null,
      audioData: null,
      infoAudio: {
        duration: 0,
        readyForSend: false
      },
      recorder: new MicRecorder({
        bitRate: BITRATE_AUDIO
      })
    }));
  };

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
  }
  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps, prevState) {
    const { infoAudio, audioData } = this.state;
    if (infoAudio.readyForSend && audioData) {
      this.sendToS3();
    }
  }

  render() {
    const { recordState } = this.state;

    const TimerAudio = () => {
      const { seconds, minutes } = useStopwatch({
        autoStart: recordState === "start"
      });

      return (
        <div className="timer-text">
          {minutes > 9 ? minutes : `0${minutes}`}:
          {seconds > 9 ? seconds : `0${seconds}`}
        </div>
      );
    };

    return (
      <div>
        {/* <audio
          id="audio"
          controls
          src={audioData ? audioData.url : null}
        ></audio> */}

        <div className="button-icon">
          {!recordState || recordState === "stop" ? (
            <img
              onClick={this.start}
              src="/images/icons/mic.png"
              alt="mic"
              className="flip-in-hor-bottom timer-action"
            ></img>
          ) : (
            <div className="center-all flip-in-hor-bottom">
              <img
                className="timer-action"
                onClick={this.cancelAudio}
                src="/images/icons/cancel-audio.png"
                alt="cancel"
              ></img>
              <div className="timer-dot color-transparent-change"></div>
              <TimerAudio />
              <img
                className="timer-action"
                onClick={this.sendAudio}
                src="/images/icons/check-audio.png"
                alt="play"
              ></img>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const obj = {};

  return obj;
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AudioRecorder))
);
